import React from 'react';

import { parseNumberStringToCurrency } from 'src/utils/Dashboard';

import styles from './ExpensesMonthly.scss';

const PieChartTooltip = ({ active, payload }) => {
  if (active) {
    return (
      <div className={styles.tooltip}>
        <div className={styles.content}>
          <div className={styles.title} style={{ color: payload[0].payload.color }}>
            {payload[0].name}
          </div>
          <div>{parseNumberStringToCurrency(payload[0].value)}</div>
        </div>
      </div>
    );
  }
  return null;
};

export default PieChartTooltip;
